







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import moment from 'moment'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import AgendamentoBackofficeStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import { AgendamentoMedico,
  Loading,
  Solicitacao,
  TipoUsuarioEnum,
  Snackbar,
  SolicitacaoQueryString } from '@/types/_'
import { AprovacoesSolicitacao } from '@/types/interfaces/AgendamentoCirurgia'
import StatusSituacao from '@/components/SolicitacaoCirurgia/store/StatusSituacao'
import { lightenDarkenColor,
  capitalizeCase,
  formatDateOnly,
  instrumentador,
  groupCollectionByDay,
  groupCollectionByWeek,
  groupCollectionByMonth } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { ComponentFiltrosAgendamentoMedicoFilterData } from '@/components/SolicitacaoCirurgia/FiltrosAgendamentoMedico.vue'
import { Hospital, Situacao, SituacaoData, Carater } from '@/types/interfaces/Solicitacao'
import { RawLocation } from 'vue-router'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'
import ConfiguracaoNotificacoesStore from '@/components/ConfiguracaoNotificacoes/Store/ConfiguracaoNotificacoesStore'
import { useMedicos } from '@/composables'
import EcgIcon from '@/utils/ecg-icon.vue'

@Component({
  components: {
    EcgIcon,
  },
})
export default class ViewAgendamentoMedico extends Vue {
  $refs!: { formEnviarLocal: any }

  mdcId: string = ''
  conf: boolean = false
  invl: boolean = false
  loadAddLocal: boolean = false
  novoLocal: string = ''
  loadHistorico: string = ''
  loadingChat: string = ''
  showAgendamentosFiltros = false

  get medicoId() { return this.mdcId }
  set medicoId(value: string) { this.mdcId = value }

  // #region Filter

  filteredAgendamentosMedico: AgendamentoMedico[] = []
  filterData = {}
  doctorFilterOptions: { id: string; nome: string }[] = []
  statusesFilterOptions: Situacao[] = []
  statusesReservationFilterOptions: SituacaoData[] = []
  carateresCirurgiasFilterOptions: Carater[] = []
  hospitalsFilterOptions: Hospital[] = []
  statusesFilterOptionsGroupMap = new Map<string, Situacao[]>()
  convertedDateStart = {}
  convertedDateEnd = {}
  loadingRefreshSurgerySolicitationList: boolean = false

  paginator = {
    total: 0,
    page: 1,
    pageLength: 25,
    pageNumbers: () => Math.ceil(this.paginator.total / this.paginator.pageLength),
    buttonsLength: () => {
      if (this.$vuetify.breakpoint.smAndDown) return 4
      if (this.$vuetify.breakpoint.md) return 7
      if (this.$vuetify.breakpoint.lg) return 9
      return 10
    },
  }

  async refreshSurgerySolicitationList() {
    try {
      this.loadingRefreshSurgerySolicitationList = true
      this.filterAgendamentosMedico(this.filterData)
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingRefreshSurgerySolicitationList = false
    }
  }

  async filterAgendamentosMedico(filterData?: ComponentFiltrosAgendamentoMedicoFilterData, resetPage = true) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.filterData = filterData || {} // Update filter data

    if (resetPage) {
      this.paginator.page = 1
    }

    // Create request query params
    const query: SolicitacaoQueryString = {
      orderBy: this.getOrdenacao,
      pagina: this.paginator.page,
      qtdPorPagina: this.paginator.pageLength,
    }

    // Get filter attributes
    const { doctorId, patient, status, statusReservation, caraterCirurgia, hospitals, surgeryStartAt, surgeryEndAt } = filterData || {}

    if (doctorId) {
      query.medicoSolicitanteId = doctorId
    }

    if (patient) {
      query.pacienteNome = patient
    }

    if (status) {
      const statuses = this.statusesFilterOptionsGroupMap.get(status) || []
      query.solicitacaoSituacao = statuses.map(elem => elem.key)
    }

    if (statusReservation) {
      query.solicitacaoSituacaoData = statusReservation
    }

    if (caraterCirurgia) {
      query.caraterCirurgia = caraterCirurgia
    }

    if (hospitals) {
      query.solicitacaoHospital = hospitals
    }

    if (surgeryStartAt) {
      const period = new Date(`${surgeryStartAt}T00:00:00`).toISOString()
      query.dataAgendamentoInicio = period
    }

    if (surgeryEndAt) {
      const period = new Date(`${surgeryEndAt}T00:00:00`).toISOString()
      query.dataAgendamentoFim = period
    }

    this.getSolicitacaoStore.clearAgendamentosMedico()
    await this.getSolicitacaoStore.LoadAgendamentosMedico(query)

    this.filteredAgendamentosMedico = this.getSolicitacaoStore.agendamentosMedico
    this.paginator.total = this.getSolicitacaoStore.agendamentosMedicoTotal

    // Update statuses filter options
    this.statusesFilterOptionsGroupMap.clear()
    const statusesFilterOptionsMap = new Map<string, Situacao>()
    this.getSolicitacaoStore.agendamentosSituacaoFiltros.forEach((elem) => {
      // Create set to remove the duplicates from options
      statusesFilterOptionsMap.set(elem.display, elem)

      // Use map to group status that has the same display
      const statuses = this.statusesFilterOptionsGroupMap.get(elem.display) || []
      this.statusesFilterOptionsGroupMap.set(elem.display, statuses)
      statuses.push(elem)
    })
    this.statusesFilterOptions = Array.from(statusesFilterOptionsMap.values())

    // Update statusReservation filter options
    this.statusesReservationFilterOptions = this.getSolicitacaoStore.agendamentosSituacaoDataFiltros

    // Update carater filter options
    this.carateresCirurgiasFilterOptions = [
      { key: 'Urgencia', display: 'Urgência' },
      { key: 'EletivoAutorizacao', display: 'Eletivo' },
      { key: 'EletivoSemAutorizacao', display: 'Emergência' },
      { key: 'Emergencia', display: 'Emergência' },
    ]

    // Update hospitals filter options
    this.hospitalsFilterOptions = this.getSolicitacaoStore.agendamentosHospitalFiltros

    this.clearLoadingRequest()
  }

  get totalRecords() {
    return this.getSolicitacaoStore.agendamentosMedicoTotal || 0
  }

  paginatorChange(page: number) {
    this.paginator.page = page
    this.filterAgendamentosMedico(this.filterData, false)
  }

  get canShowFilterDoctorField() {
    return instrumentador(this.$user.profile)
  }

  get canShowPaginator() {
    if (this.paginator.total > 0) {
      return true
    }
    return false
  }

  // #endregion Filter

  get canShowAddButton() {
    if (this.getOrdenacao === 'cirurgiasModelo') {
      return false
    }

    return true
  }

  fidelizationHasAcceptedDoctorJustificationStatus(doctorSurgerySolicitationData: AgendamentoMedico): boolean {
    return doctorSurgerySolicitationData.segueOProtocolo === StatusDoProtocoloEnum.fidelizacaoAceitouJustificativaMedico
  }

  canShowSeloProtocoloParaListagem(data: AgendamentoMedico) {
    return data.segueOProtocolo === StatusDoProtocoloEnum.segueOProtocolo
  }

  canShowSeloNaoSegueOProtocoloParaListagem(data: AgendamentoMedico) {
    return data.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo
  }

  canShowSeloTemProtocoloDisponivelParaListagem(data: AgendamentoMedico) {
    return data.segueOProtocolo === StatusDoProtocoloEnum.temProtocoloDisponivel
  }

  getDataOrcamentoAvulso(data: AgendamentoMedico) {
    if (data.dataValidadeOrcamentoParticularAvulso) {
      const date = moment(data.dataValidadeOrcamentoParticularAvulso).format('DD/MM/YYYY')
      return `Valido até ${date}`
    }
    return ''
  }

  getLabelDateSituation(data: AgendamentoMedico) {
    const situacaoKey = data.situacaoData && data.situacaoData.key

    // ATTENTION: This is a GAMBIARRA requested by P.O and need be removed in future
    // Check hospital is an São Camilo's unit
    const saoCamiloUnitIds = [
      'f5aa7e51-6bf6-478f-89a3-25003076b1af',
      '3ab1d911-4a0e-4dc9-b4f4-a52cc6972112',
      '52d198b6-238e-4789-8517-cd513aa7da77',
    ]

    if (saoCamiloUnitIds.includes(data.hospitalId)) {
      switch (situacaoKey) {
        case 'Solicitada':
          return 'Data Pré Agendada'

        case 'Confirmada':
          return 'Data Agendada'

        default:
          return data.situacaoData && data.situacaoData.display
      }
    }

    // Case is not São Camilo's unit
    switch (situacaoKey) {
      // This case fix the key Confirmada because it don't returns the word 'Data' together the display
      case 'Confirmada':
        return 'Data Confirmada'

      default:
        return data.situacaoData && data.situacaoData.display
    }
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  getChatInfo(data: AgendamentoMedico) {
    const { solicitacaoChatFinalizado, solicitacaoChatTotalMensagensNaoLidas } = data

    if (solicitacaoChatFinalizado === false) {
      if (solicitacaoChatTotalMensagensNaoLidas! > 0) {
        const number = solicitacaoChatTotalMensagensNaoLidas! >= 1 ? solicitacaoChatTotalMensagensNaoLidas : ''
        const text = solicitacaoChatTotalMensagensNaoLidas! > 1 ? 'Novas Mensagens' : 'Nova Mensagem'

        return { icon: 'chat', title: `${number} ${text}`, class: '-orange' }
      }

      return { icon: 'chat_bubble', title: 'Chat Aberto', class: '-yellow' }
    }

    return { icon: 'chat_bubble_outline', title: 'Nenhum Chat', class: '-gray' }
  }

  canShowChatButton(data: AgendamentoMedico) {
    if (data.situacao.key !== 'Incompleta' && data.hospitalUtilizaChat) {
      return true
    }

    return false
  }

  canShowApa(data: AgendamentoMedico) {
    if (data.apa && data.apa.notificacaoEnviada) {
      return true
    }
    return false
  }

  getApaStatus(data: AgendamentoMedico) {
    if (data.apa && data.apa.id && data.apa.id.trim() !== '') {
      return {
        iconColor: '#303F9F',
        text: 'Avaliação pré-operatória antecipada digital respondida',
      }
    }

    return {
      iconColor: '#ADAEBC',
      text: 'Avaliação pré-operatória antecipada digital pendente',
    }
  }

  get assinaturaInvalida() {
    return this.invl
  }

  set assinaturaInvalida(value: boolean) {
    this.invl = value
  }

  get configuracao() {
    return this.conf
  }

  set configuracao(value: boolean) {
    this.conf = value
  }

  get addLocalLoading() {
    return this.loadAddLocal
  }

  set addLocalLoading(value: boolean) {
    this.loadAddLocal = value
  }

  get getNovoLocal() {
    return this.novoLocal
  }

  set getNovoLocal(value: string) {
    this.novoLocal = value
  }

  enviarLocalRules: any = {
    valid: false,
    localRules: [(v: any) => !!v || 'O campo Local de Atendimento é obrigatório.'],
    medicoId: [(v: any) => this.validateMedicoId(v) || 'É necessário informar o nome de um médico.'],
  }

  validateMedicoId(value: string = '') {
    if (this.doctors.length === 0) return true
    if (value !== '') return true
    return false
  }

  order(json: AgendamentoMedico[], field: string = 'dataAgendamento') {
    if (json.length < 1) return []

    const group = groupCollectionByMonth(json, field)

    // @ts-ignore
    for (let i = 0; i < group.length; i++) {
      // @ts-ignore
      group[i].children = groupCollectionByWeek(group[i].children)

      // @ts-ignore
      for (let j = 0; j < group[i].children.length; j++) {
        // @ts-ignore
        group[i].children[j].children = groupCollectionByDay(
          // @ts-ignore
          group[i].children[j].children,
        )
      }
    }

    return group
  }

  formatDateObject(data: string, format: string) {
    return moment(data).format(format)
  }

  formatCard(situacao: string) {
    switch (situacao) {
      case 'Enviado':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'Incompleta':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'PreReserva':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'Autorizada':
        return { background: 'light-green lighten-4', text: '#292929' }

      case 'EmAutorizacao':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AnalisePreAutorizacao':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AnalisePreCotacao':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AnalisePosCotacao':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'Pendente':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'PendenciaAdministrativa':
        return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

      case 'PendenciaRespondida':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'EmTriagem':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AlteracaoDeCarater':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AguardandoOperadora':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'EmCotacao':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AutorizadaParcial':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'AutorizadaAceitaMedico':
        return { background: 'light-green lighten-4', text: '#292929' }

      case 'ContestacaoMedica':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'ContestacaoPendente':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'Cancelada':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'CancelamentoSolicitado':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'IntegracaoNegadaPeloAutorizador':
        return { background: 'deep-orange lighten-5', text: '#292929' }

      case 'LiberadoParaAgendamento':
        return { background: 'light-green lighten-4', text: '#292929' }

      case 'AutorizacaoNegadaPeloAutorizador':
        return { background: 'deep-orange lighten-3', text: 'deep-orange darken-4' }

      case 'EnviadoParaOAutorizador':
        return { background: 'light-blue lighten-4', text: '#292929' }

      case 'ExigenciaDoAutorizador':
        return { background: 'light-blue lighten-4', text: '#292929' }

      default:
        return { background: 'deep-orange lighten-5', text: '#292929' }
    }
  }

  formatToday(data: string) {
    return moment(data).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
      ? 'rounded elevation-1'
      : 'flat'
  }

  formatSchedule(data: string, duracao: number = 0) {
    return `${moment(data).format('HH:mm')} - ${moment(data).add(duracao, 'minutes').format('HH:mm')}`
  }

  get maxWidth() {
    if (this.$vuetify.breakpoint.xs) return '263px'
    if (this.$vuetify.breakpoint.sm) return '417px'
    return '558px'
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Medico
  loading: Loading = {
    status: false,
    text: '',
  }

  statuses: { textColor?: string, color: string; icon: string; text: String[] }[] = [
    {
      // color: '#ff5252',
      color: '#E62D3B',
      textColor: '#FFFFFF',
      icon: 'error_outline',
      text: ['Negada', 'Cancelada', 'Cancelado', 'AutorizacaoNegadaPeloAutorizador', 'IntegracaoNegadaPeloAutorizador'],
    },
    {
      // color: '#2196f3',
      color: '#F8BBD0',
      icon: 'done',
      text: ['Pré-agendamento', 'Revisão cirúrgica'],
    },
    {
      // color: '#fb8c00',
      color: '#FFE7CC',
      icon: 'warning',
      text: [
        'Incompleta',
        'revisaoAIH',
        'PreviaIncompleta',
        'PreReserva',
        'Pendência',
        'Cancelamento solicitado',
        'Pendência em análise',
        'Autorizada Parcial',
        'Cancelamento Solicitado',
        'Contestação Médica',
        'Contestação Pendente',
        'Em triagem',
      ],
    },
    {
      color: '#03A5ED',
      icon: 'done',
      text: [
        'Enviado',
        'EnviadoParaOAutorizador',
        'Enviada',
        'Cotação',
        'Em Autorização',
        'Em análise',
        'Pendência Respondida',
        'Aguardando Autorização',
        'Aguardando Cotação',
      ],
    },
    {
      color: '#C8EFBC',
      icon: 'done_all',
      text: ['Autorizada'],
    },
    {
      color: '#69F0AE',
      icon: 'done',
      text: ['DisponivelParaEnvio', 'LiberadoParaAgendamento'],
    },
    {
      color: '#039BE5',
      icon: 'warning',
      text: ['PreviaCirurgica'],
    },
  ]

  get userHasAccessToOnlyOneHospitalAndHospitalHasTermsOfUseDidNotAccepted() {
    const hasAccessToOnlyOneHospital = this.getSolicitacaoStore.currentUserHospitals.length === 1
    let hospitalData

    if (hasAccessToOnlyOneHospital) {
      [hospitalData] = this.getSolicitacaoStore.currentUserHospitals
    }

    const hospitalHasTermsOfUse = hospitalData && hospitalData.hospitalPossuiTermoDeUso
    const userAcceptedHospitalTermsOfUse = hospitalData && hospitalData.termoDeUsoAceitoPeloUsuario

    return hospitalHasTermsOfUse && userAcceptedHospitalTermsOfUse
  }

  async showModalHospitalOpcoes() {
    const isInstrumentador: boolean = instrumentador(this.$user.profile)

    if (this.getSolicitacaoStore.hospitais.length === 1
      && !isInstrumentador
      && this.userHasAccessToOnlyOneHospitalAndHospitalHasTermsOfUseDidNotAccepted) {
      const template = await this.getSolicitacaoStore.loadHospitalTemplate(this.getSolicitacaoStore.hospitais[0].id)
      await this.getSolicitacaoStore.getHospitalById(this.getSolicitacaoStore.hospitais[0].id)

      const route = {
        name: 'SolicitacaoCirurgia',
        params: {
          hospitalId: this.getSolicitacaoStore.hospital.id,
          medicoId: this.$user.profile.sub,
          medico: this.$user.profile.name,
          hospitalNome: this.getSolicitacaoStore.hospital.nome,
          solicitacaoId: 'new',
        },
      }

      this.$router.push(route)
    } else {
      this.getSolicitacaoStore.showModalHospitalOpcoes(true)
    }

    this.ga('agendamento-medico', 'adicionar-solicitacao')
  }

  async editarAgendamentoCirurgia(agendamentoMedico: AgendamentoMedico) {
    await this.getSolicitacaoStore.setTemplateHospital(agendamentoMedico.template)
    this.getSolicitacaoStore.setHospitalId(agendamentoMedico.hospitalId)
    this.getSolicitacaoStore.setMedicoId(agendamentoMedico.medicoSolicitanteId)

    const statusParaIgnorarEdicao = [
      String(StatusSituacao.StatusSituacao.Incompleta),
      String(StatusSituacao.StatusSituacao.RevisaoAIH)];

    if (
      agendamentoMedico.situacao
      && !statusParaIgnorarEdicao.includes(agendamentoMedico.situacao.key)
    ) {
      this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
      await this.getSolicitacaoPendenciaStore.setAgendamentoMedicoAndLocais(agendamentoMedico)
      this.clearLoadingRequest()
      this.getSolicitacaoStore.setShowModalGerenciar(true)
    } else {
      const route = {
        name: 'SolicitacaoCirurgia',
        params: {
          solicitacaoId: agendamentoMedico.id || '',
          hospitalId: agendamentoMedico.hospitalId,
          medico: agendamentoMedico.nomeMedico,
          medicoId: agendamentoMedico.medicoSolicitanteId,
        },
      }

      this.getSolicitacaoStore.clearAgendamentosMedico()
      this.getSolicitacaoStore.setShowForm(agendamentoMedico.acoes.editar)
      this.$router.push(route)
    }

    this.getAgendamentoBackofficeStore.setNomePaciente(agendamentoMedico.paciente || '')
    this.getAgendamentoBackofficeStore.setNomeMedicoSolicitante(agendamentoMedico.nomeMedico)
  }

  async editarCirurgiaModelo(data: AgendamentoMedico) {
    await this.getSolicitacaoStore.setTemplateHospital(data.template)

    const route = {
      name: 'SolicitacaoCirurgia',
      params: {
        solicitacaoId: data.id || '',
        hospitalId: data.hospitalId,
        medico: data.nomeMedico,
        medicoId: data.medicoSolicitanteId,
      },
      query: { editModelMode: 'true' },
    } as RawLocation

    this.getSolicitacaoStore.clearAgendamentosMedico()
    this.getSolicitacaoStore.setShowForm(data.acoes.editar)
    this.$router.push(route)

    this.getAgendamentoBackofficeStore.setNomePaciente(data.paciente || '')
    this.getAgendamentoBackofficeStore.setNomeMedicoSolicitante(data.nomeMedico)
  }

  async editarOrcamentoParticularAvulso(data: AgendamentoMedico) {
    await this.getSolicitacaoStore.setTemplateHospital(data.template)

    const route = {
      name: 'SolicitacaoCirurgia',
      params: {
        solicitacaoId: data.id || '',
        hospitalId: data.hospitalId,
        medico: data.nomeMedico,
        medicoId: data.medicoSolicitanteId,
      },
      query: { budgetMode: 'true' },
    } as RawLocation

    this.getSolicitacaoStore.clearAgendamentosMedico()
    this.getSolicitacaoStore.setShowForm(data.acoes.editar)
    this.$router.push(route)

    this.getAgendamentoBackofficeStore.setNomePaciente(data.paciente || '')
    this.getAgendamentoBackofficeStore.setNomeMedicoSolicitante(data.nomeMedico)
  }

  capitalLetters(text: string) {
    return capitalizeCase(text)
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest.status = status
    this.loadingRequest.text = text
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  setDate(date: string) {
    return moment(date, 'DD/MM/YYYY').format('DD/MM/YY')
  }

  timeAgo(dateString) {
    const now = new Date()
    const past = new Date(dateString)
    const seconds = Math.floor((now.getTime() - past.getTime()) / 1000)

    let interval = Math.floor(seconds / 31536000)
    if (interval >= 1) {
      return interval === 1 ? '1 ano atrás' : `${interval} anos atrás`
    }
    interval = Math.floor(seconds / 2592000)
    if (interval >= 1) {
      return interval === 1 ? '1 mês atrás' : `${interval} meses atrás`
    }
    interval = Math.floor(seconds / 86400)
    if (interval >= 1) {
      return interval === 1 ? '1 dia atrás' : `${interval} dias atrás`
    }
    interval = Math.floor(seconds / 3600)
    if (interval >= 1) {
      return interval === 1 ? '1 hora atrás' : `${interval} horas atrás`
    }
    interval = Math.floor(seconds / 60)
    if (interval >= 1) {
      return interval === 1 ? '1 minuto atrás' : `${interval} minutos atrás`
    }
    return 'agora mesmo'
  }

  gerarChipsDeAprovacao(dados: AprovacoesSolicitacao[]) {
    if (!dados || !dados.length) return []

    const pendente = dados.find(d => d.statusAprovacao === 'Pendente')
    if (pendente) {
      return [
        {
          color: '#FFE7CC',
          icon: 'warning',
          text: 'Aprovação: Pendente',
        },
        {
          color: '#FFE7CC',
          icon: 'warning',
          text: `Aguardando aprovação: ${this.timeAgo(pendente.criadaEm)}`,
        },
      ]
    }

    const reprovada = dados.find(d => d.statusAprovacao === 'Reprovada')
    if (reprovada) {
      return [
        {
          color: '#E62D3B',
          icon: 'error_outline',
          text: 'Aprovação: Reprovada',
        },
      ]
    }

    const aprovada = dados.find(d => d.statusAprovacao === 'Aprovada')
    if (aprovada) {
      return [
        {
          color: '#CCFFCC',
          icon: 'done',
          text: 'Aprovação: Aprovada',
        },
      ]
    }

    return []
  }

  setChip(status: any): object {
    let myColor = ''
    let myIcon = ''
    let textColor = ''
    this.statuses.forEach((e) => {
      if (e.text.includes(status)) {
        myColor = e.color
        myIcon = e.icon
        textColor = e.textColor || ''
      }
    })
    return { color: myColor, icon: myIcon, textColor }
  }

  setChipTextColor(color: string) {
    return lightenDarkenColor(color, -130)
  }

  get loadingRequest() {
    return this.loading
  }

  set loadingRequest(value: Loading) {
    this.loading = value
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get surgerySolicitationStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getAgendamentoBackofficeStore() {
    return getModule(AgendamentoBackofficeStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getSnackbar() {
    return this.getSolicitacaoStore.snackbar
  }

  set getSnackbar(value: Snackbar) {
    this.getSolicitacaoStore.setSnackbar(value)
  }

  get getOrdenacao() {
    return this.getSolicitacaoStore.filterCirurgias
  }

  set getOrdenacao(value: string) {
    this.getSolicitacaoStore.setFilterCirurgias(value)
  }

  get previaCirurgicaEnabled() {
    return this.filteredAgendamentosMedico.some((agendamento: AgendamentoMedico) => ['PreviaCirurgica', 'DisponivelParaEnvio'].includes(agendamento.situacao.key))
  }

  get alertaDisponivelParaEnvio() {
    return this.filteredAgendamentosMedico.some((agendamento: AgendamentoMedico) => ['DisponivelParaEnvio'].includes(agendamento.situacao.key))
  }

  get isDoctorAndSomeHospitalHasDoctorExecutantFlagEnabled(): boolean {
    return !this.isDoctorSecretary && this.getSolicitacaoStore.agendamentosHospitalFiltros.some((hospital: Hospital) => !!hospital.alterarMedicoSolicitante)
  }

  get sortOptions() {
    const sortOptions = [
      { id: 'dataStatusAlterado', text: 'Últimas alterações' },
      { id: 'dataAgendamento', text: 'Próximas Cirurgias' },
      { id: 'cirurgiasRealizadas', text: 'Cirurgias Realizadas' },
      { id: 'cirurgiasModelo', text: 'Cirurgias Favoritas' },
      { id: 'orcamentoParticularAvulso', text: 'Orçamento Avulso' },
    ]

    if (this.previaCirurgicaEnabled) {
      sortOptions.push({ id: 'gestaoPreviaCirurgia', text: 'Gestão de prévias cirúrgicas' })
    }

    if (this.isDoctorAndSomeHospitalHasDoctorExecutantFlagEnabled) {
      sortOptions.push({ id: 'medicoPrescritor', text: 'Cirurgias Encaminhadas' })
    }

    return sortOptions
  }

  formatEvent(event: string) {
    switch (event) {
      case 'dataAgendamento':
        return 'filtro-proximas-cirurgias'
      case 'cirurgiasRealizadas':
        return 'filtro-cirurgias-realizadas'
      case 'cirurgiasModelo':
        return 'filtro-cirurgias-modelo'
      default:
        return 'filtro-ultimas-alteracoes'
    }
  }

  async ordenacaoChange(event: any) {
    this.ga('agendamento', this.formatEvent(event))
    this.filterAgendamentosMedico(this.filterData)
  }

  closeSnackbar() {
    const { snackbar } = this.getSolicitacaoStore
    snackbar.show = false
    this.getSolicitacaoStore.setSnackbar(snackbar)
  }

  closeModalCancelamento(solicitacao: Solicitacao) {
    this.getSolicitacaoPendenciaStore.setAcoes(solicitacao.acoes)
  }

  async adicionarLocal() {
    this.addLocalLoading = true

    if (this.$refs.formEnviarLocal.validate()) {
      const params: any = {
        medicoId: this.doctors.length > 0 ? this.medicoId : this.$user.profile.sub,
        LocalAtendimentoNome: this.getNovoLocal,
      }

      const request = await this.getSolicitacaoStore.adicionaMedicoLocalAtendimento(params)
      if (request) {
        this.closeModalLocal()
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Obrigado pelas informações!',
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Houve um erro no envio.',
          icon: 'warning',
          color: '#C62828',
        })
      }
    }


    this.addLocalLoading = false
  }

  closeModalLocal() {
    this.$refs.formEnviarLocal.reset()
    this.$refs.formEnviarLocal.resetValidation()
    this.medicoId = ''
    this.getNovoLocal = ''
    this.configuracao = false
  }

  get getConfiguracaoNotificacoesStore() {
    return getModule(ConfiguracaoNotificacoesStore, this.$store)
  }

  get doctors() {
    return useMedicos.medicosByInstrumentador
  }

  async fetchDoctors() {
    await useMedicos.loadMedicosByInstrumentador()
  }

  get isDoctorSecretary() {
    return instrumentador(this.$user.profile)
  }

  async Init() {
    this.setLoadingRequest(
      this.getRequestMessage.status,
      this.getRequestMessage.init.text,
    )

    // Get configurations
    let configuracaoRequest = this.getConfiguracaoNotificacoesStore.configuracaoNotificacoes
    if (!configuracaoRequest.length) {
      configuracaoRequest = await this.getSolicitacaoStore.getConfiguracoes()
      if (configuracaoRequest) {
        this.getConfiguracaoNotificacoesStore.setConfiguracoesNotificacoes(configuracaoRequest)
      }
    }

    await this.getSolicitacaoStore.getHospitaisByUserCurrent()

    this.clearLoadingRequest()

    // If config is ok, call filterAgendamentosMedico to load the schedulings
    if (configuracaoRequest && configuracaoRequest.length > 0 && this.checkLocalAtendimento(configuracaoRequest)) {
      this.filterAgendamentosMedico()
    } else if (configuracaoRequest) {
      if (this.isDoctorSecretary) await this.fetchDoctors()
      this.configuracao = true
    }
  }

  checkLocalAtendimento(medicos: any) {
    return medicos.some((e: any) => e.locaisAtendimento)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  // FXIA-15712: autorizada com aceite médico da autorização parcial exibe
  // "Autorizada Parcial" para o médico/secretária; o status AutorizadaParcial
  // mantém o texto padronizado independente do display do enum
  displaySituacao(agendamentoMedico: any) {
    if (agendamentoMedico.situacao.key === 'AutorizadaParcial') return 'Autorizada Parcial'

    if (agendamentoMedico.situacao.key === 'Autorizada' && agendamentoMedico.autorizacaoParcialAceitaPeloMedico) return 'Autorizada Parcial'

    return agendamentoMedico.situacao.display
  }

  async mounted() {
    await this.Init()
  }
}
